'use strict';

import React from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import CreditNoteForm from '@/Form/CreditNoteForm'

import Link from '@Pure/Link'

export default PageWrapper(function NewCreditNotePage (props)
{
	return (
		<Layout page_title="Nouvel avoir" history={ props.history }>

			<div className="page-content">

				<div className="u-flex u-content-end u-margin-bottom-20">
					<Link href="/gestion-des-avoirs"
						className="c-btn u-no-margin-top">
						Retour aux avoirs
					</Link>
				</div>

				<CreditNoteForm type="create" />

			</div>

		</Layout>
	);
});